module.exports = __webpack_public_path__ + "static/media/force_img.359c9e21.jpg";